module.exports = "/images/Badge.svg?a5216a2b3c6ff954b0458a3975c26515";